import React from "react";
import {
  AppBar,
  Toolbar,
  Box,
  List,
  ListItem,
  Typography,
  styled,
  ListItemButton,
  ListItemText,
} from "@mui/material";
// menu
import DrawerItem from "./DrawerItem";
// rotas
import { Link } from "react-router-dom";
// selector de idiomas
import LanguageSelector from "../components/LanguageSelector";
// traducciones
import { useTranslation } from "react-i18next";

// Logo para el Navbar (versión pequeña)
const NavbarLogo = styled(Box)(({ theme }) => ({
  width: '60px',
  height: '60px',
  borderRadius: '50%',
  backgroundColor: '#000000',
  border: '2px solid #ffffff',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(0.5),
  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.2)',
  cursor: 'pointer',
  [theme.breakpoints.down('sm')]: {
    width: '50px',
    height: '50px',
  },
}));

const LogoMainText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontWeight: 'bold',
  fontSize: '1rem',
  textAlign: 'center',
  textTransform: 'uppercase',
  fontFamily: 'sans-serif',
  lineHeight: 1,
  marginBottom: '1px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.85rem',
  },
}));

const LogoSubText = styled(Typography)(({ theme }) => ({
  color: '#ffffff',
  fontWeight: 'normal',
  fontSize: '0.35rem',
  textAlign: 'center',
  textTransform: 'uppercase',
  fontFamily: 'sans-serif',
  lineHeight: 1,
  [theme.breakpoints.down('sm')]: {
    fontSize: '0.3rem',
  },
}));

// personalizacao
const StyledToolbar = styled(Toolbar)({
  display: "flex",
  justifyContent: "space-between",
});

const ListMenu = styled(List)(({ theme }) => ({
  display: "none",
  [theme.breakpoints.up("sm")]: {
    display: "flex",
  },
}));

const Navbar = () => {
  const { t } = useTranslation();

  //rotas
  const itemList = [
    {
      text: t("nav.home"),
      to: "/",
    },
    /* {
      text: t("nav.about"),
      to: "/about",
    }, */
    {
      text: t("nav.blog"),
      to: "/blog",
    },
    {
      text: t("nav.contact"),
      to: "/contact",
    },
  ];

  return (
    <AppBar
      component="nav"
      position="sticky"
      sx={{
        backgroundColor: "white",
        border: "1px solid rgba(0, 0, 0, 0.2)",
        boxShadow: "0 4px 10px rgba(0, 0, 0, 0.3)",
        marginBottom: "20px", // Espacio inferior
      }}
      elevation={0}
    >
      <StyledToolbar>
        <Box
          component={Link}
          to="/"
          sx={{
            display: 'flex',
            alignItems: 'center',
            textDecoration: 'none',
            gap: 1,
          }}
        >
          <NavbarLogo>
            <LogoMainText>PXT</LogoMainText>
            <LogoSubText>PEOPLEFORTECH</LogoSubText>
          </NavbarLogo>
          <Typography
            variant="h6"
            component="h1"
            sx={{
              color: 'black',
              fontWeight: 600,
              fontSize: '1.2rem',
              display: { xs: 'none', sm: 'block' },
            }}
          >
            PeopleForTech
          </Typography>
        </Box>
        <Box sx={{ display: { xs: "none", sm: "flex" }, alignItems: "center", gap: 2 }}>
          <ListMenu>
            {itemList.map((item) => {
              const { text } = item;
              return (
                <ListItem key={text}>
                  <ListItemButton
                    component={Link}
                    to={item.to}
                    sx={{
                      color: "black",
                      "&:hover": {
                        backgroundColor: "transparent",
                        color: "#1e2a5a",
                      },
                    }}
                  >
                    <ListItemText primary={text} />
                  </ListItemButton>
                </ListItem>
              );
            })}
          </ListMenu>
          <LanguageSelector />
        </Box>
        <Box sx={{ display: { xs: "flex", sm: "none" }, alignItems: "center", gap: 1 }}>
          <LanguageSelector />
          <DrawerItem />
        </Box>
      </StyledToolbar>
    </AppBar>
  );
};

export default Navbar;
